import { AuthService } from 'src/app/core/auth/auth.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take, tap, filter } from 'rxjs/operators';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.auth.state$.pipe(
      filter((authState) => authState.status !== 'loading'),
      take(1),
      tap((authState) => {
        if (authState.status === 'initialized' && !authState.user) {
          this.auth.login(state.url);
        }
      }),
      map((authState) => !!authState.user)
    );
  }
}
